import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { YearlyDailyRateReport } from "~/modules/reports/api/dailyRateReport/dailyRateReportTypes.ts";

const dailyRateReportBasePath = "reports/daily-rate";

export function getYearlyDailyRateReport(year: string): AxiosApiResponsePromise<YearlyDailyRateReport> {
	return axiosApi.get(`${dailyRateReportBasePath}/${year}`);
}
